import { State, Action, Selector, StateContext, Store } from '@ngxs/store';
import {
  ToggleSidebar,
  InitNavState,
  StartLoading,
  FinishLoading,
  SetLinks
} from './navigation.actions';
import { Router } from '@angular/router';
import { LocalStorageService } from '@leagueplay/shared/local-storage';
import { NgZone } from '@angular/core';

const SIDEBAR_EXPANDED = 'sidebar-expanded';

export interface NavigationStateModel {
  isLoading: boolean;
  sideLinks: any[];
  sidebarExpanded: boolean;
  currentUri: string;
}

@State<NavigationStateModel>({
  name: 'navigation',
  defaults: {
    isLoading: false,
    currentUri: '',
    sidebarExpanded: true,
    sideLinks: [
      {
        title: null,
        links: [
          {
            label: 'HOME',
            icon: 'fas fa-home',
            value: `/`
          },
          {
            label: 'COMMUNITIES',
            icon: 'fas fa-users',
            value: `/communities`
          }
        ]
      },
      {
        title: 'DASHBOARD',
        links: [
          {
            label: 'MESSAGES',
            icon: 'fas fa-envelope',
            value: '/messages'
          },
          {
            label: 'UPCOMING',
            icon: 'fas fa-calendar',
            value: '/upcoming'
          }
        ]
      }
    ]
  }
})
export class NavigationState {
  constructor(
    private store: Store,
    public router: Router,
    public ngZone: NgZone,
    public localStorage: LocalStorageService
  ) {
    setTimeout(() => {
      this.store.dispatch(new InitNavState());
    }, 0);
  }

  @Selector()
  public static sideLinks(state: NavigationStateModel) {
    return state.sideLinks;
  }

  @Selector()
  public static sidebarExpanded(state: NavigationStateModel) {
    return state.sidebarExpanded;
  }

  @Selector()
  public static currentUri(state: NavigationStateModel) {
    return state.currentUri;
  }

  @Selector()
  public static isLoading(state: NavigationStateModel) {
    return state.isLoading;
  }

  @Action(InitNavState)
  public initState(
    context: StateContext<NavigationStateModel>,
    action: InitNavState
  ) {
    const state = context.getState();

    const savedValue = this.localStorage.get(SIDEBAR_EXPANDED);

    state.sidebarExpanded = savedValue === false ? false : true;
    this.localStorage.save(SIDEBAR_EXPANDED, state.sidebarExpanded);
    context.patchState(state);
  }

  @Action(StartLoading)
  public startLoading(
    context: StateContext<NavigationStateModel>,
    action: StartLoading
  ) {
    const state = context.getState();
    state.isLoading = true;
    context.patchState(state);
  }

  @Action(FinishLoading)
  public finishLoading(
    context: StateContext<NavigationStateModel>,
    action: FinishLoading
  ) {
    const state = context.getState();
    state.isLoading = false;
    context.patchState(state);
  }

  @Action(ToggleSidebar)
  public toggleSidebar(
    context: StateContext<NavigationStateModel>,
    action: ToggleSidebar
  ) {
    const state = context.getState();
    state.sidebarExpanded = !state.sidebarExpanded;
    this.localStorage.save(SIDEBAR_EXPANDED, state.sidebarExpanded);
    context.patchState(state);
  }

  @Action(SetLinks)
  public setLinks(
    context: StateContext<NavigationStateModel>,
    { links }: SetLinks
  ) {
    const state = context.getState();
    state.sideLinks = links;
    context.patchState(state);
  }
}
